var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rich-suggestion',{ref:"suggestion",attrs:{"editor":_vm.editor,"lookup-function":_vm.findMatches,"plugin-name":"suggestion-image","matcher-char":"$","mention-class":"badge badge-image","mention-type":"thumbnail","icon-class":"fa-eye"},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_vm._v(" $"+_vm._s(item.label)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }